import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'materialIconName',
})
export class MaterialIconName implements PipeTransform {
  transform(element: any, casename: number = 1): any {
    try {
      if (casename === 1) {
        if (element.display_file_name == undefined) {
          return 'doc';
        }
        let type = element.display_file_name.replace(/^.*\./, '') != element.display_file_name ? element.display_file_name.replace(/^.*\./, '') : '';
        if (type == '') {
          return 'doc';
        } else {
          return type.toLowerCase();
        }
      } else {
        const url = element.upload_path;
        const fileName = url.split('/').pop().split('?')[0]; // Extract file name
        const fileExtension = fileName.split('.').pop();

        if (element.form_name == undefined) {
          return 'doc';
        }
        let type = fileExtension;
        if (type == '') {
          return 'doc';
        } else {
          return type.toLowerCase();
        }
      }
    } catch (error) {
      return 'doc';
    }
  }
}
